<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header
      titleKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.service.fees"
      tooltipKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.service.fees.tooltip"
      [title]="feeCategories.findLabel('service').title"
      [tooltip]="feeCategories.findLabel('service').tooltip"
    ></app-panel-header>
    <span class="panel-header-key-value">
      <span> {{ 'common.total' | transloco }}: </span>
      <span class="font-bold text-orange-500">
        {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
      </span>
    </span>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <form [formGroup]="theForm">
    <ng-container formArrayName="data">
      <p-table [value]="feeRows()" [rowTrackBy]="trackByIndex" class="p-datatable-gridlines">
        <ng-template #header>
          <tr>
            <th>{{ 'common.functions' | transloco }}</th>
            <th>{{ 'common.office.locations' | transloco }}</th>
            <th>{{ 'common.headcount' | transloco }}</th>
            <th class="min-w-[8%]">{{ 'common.headcount.eligible' | transloco }}</th>
            <th>{{ 'common.launch.year' | transloco }}</th>
            <th class="min-w-[8%]">{{ 'service.fee.perEmployee' | transloco }}</th>

            @for (year of inputObject().scopeYears; track year) {
              <th class="w-[9%] text-right">{{ 'common.year' | transloco }} {{ year }}</th>
            }

            <th class="w-[9%] text-right">{{ 'common.total' | transloco }}</th>
            <th class="w-[3%] text-right">{{ 'common.comment' | transloco }}</th>
          </tr>
        </ng-template>

        <ng-template #body let-row let-rowIndex="rowIndex">
          <tr [formGroupName]="rowIndex">
            <td>{{ row.data.moduleFunction?.translations | translateDirectus }}</td>

            <td class="py-2">
              @for (office of row.data.offices; track office.officeLookupResponse.id) {
                <div class="block leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
                  {{ office.officeLookupResponse.countryCode }} |
                  {{ office.officeLookupResponse.city }} | {{ office.officeLookupResponse.name }}
                </div>
              }
            </td>

            <td>{{ row.officeHeadcount }}</td>
            <td class="w-[8%] text-right">
              <app-form-field-number
                [id]="'eligibleHeadcount-' + rowIndex"
                [icon]="'pi pi-user'"
                [fieldName]="'eligibleHeadcount'"
                [locale]="inputObject().locale"
                [showButtons]="false"
                [mode]="'integer'"
                [isReadOnly]="isReadOnly()"
                [min]="0"
                [max]="row.officeHeadcount"
              ></app-form-field-number>
            </td>
            <td>
              @for (
                officeProject of row.data.offices;
                track officeProject.officeLookupResponse.id
              ) {
                <div class="block leading-tight whitespace-nowrap overflow-hidden text-ellipsis">
                  {{ officeProject.goLiveDate | date: 'MMM.yyyy' }}
                </div>
              }
            </td>

            <td class="w-[8%] text-right">
              <app-form-field-number
                [id]="'feePerUnit-' + rowIndex"
                [icon]="extractCurrencyIcon(inputObject().currencyCode)"
                [fieldName]="'feePerUnit'"
                [locale]="inputObject().locale"
                [showButtons]="false"
                [mode]="'decimal'"
                [isReadOnly]="isReadOnly()"
              ></app-form-field-number>
            </td>

            @for (fee of row.yearlyFees; track $index) {
              <td class="w-[9%] text-right">
                {{ fee ? (fee | appCurrency: inputObject() : 0 : 0) : '---' }}
              </td>
            }

            <td class="w-[9%] font-semibold text-right">
              {{ row.totalAcrossScope | appCurrency: inputObject() : 0 : 0 }}
            </td>
            <td class="w-[3%] text-right">
              <app-comment-modal-button
                [isReadOnly]="isReadOnly()"
                [control]="theForm.get('data.' + rowIndex + '.comment')"
              ></app-comment-modal-button>
            </td>
          </tr>
        </ng-template>

        <ng-template #footer>
          <tr class="font-bold">
            <td>{{ 'common.total' | transloco }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            @for (year of inputObject().scopeYears; track year) {
              <td class="w-[9%] text-right">
                {{ this.columnTotalsPerYear()[year - 1] | appCurrency: inputObject() : 0 : 0 }}
              </td>
            }
            <td class="w-[9%] text-right">
              {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
            </td>
            <td class="w-[3%]"></td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    @if (!isReadOnly() && theForm.valid && hasChanges()) {
      <div class="flex justify-end gap-2 mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </form>
</p-panel>
